import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {attributeHelpCenterClick, prefetchHelpCenterIdentity} from "../../utils/HelpCenterAttribution";


export const HELP_FLEX_INDICATORS = 'FLEX_INDICATORS';
export const HELP_CHAT_CHANNEL_ID = "CHAT_CHANNEL_ID";
export const HELP_SHEET = 'SHEET';
export const HELP_WEBHOOK = 'WEBHOOK';
export const HELP_GA4_THOU_SHEETS = 'GA4_THOU_SHEETS';
export const HELP_GA4 = 'GA4';
export const HELP_LOOKER_CC = 'LOOKER_CC';
export const HELP_DATA_NODE = 'DATA_NODE';
export const HELP_DATA_EXPLORER = 'DATA_EXPLORER';
export const HELP_MCP = 'MCP';
export const HELP_MCP_INTERNAL = 'MCP_INTERNAL';
export const HELP_NO_BUDGETS_ASSIGNED = 'NO_BUDGETS_ASSIGNED';
export const HELP_BU_CONFIGURATION_TYPES = 'BU_CONFIGURATION_TYPES';
export const HELP_FACEBOOK_FIXED_ACTIONS = "FACEBOOK_FIXED_ACTIONS";
export const HELP_DAILY_LIMIT = "DAILY_LIMIT";
export const HELP_IMPORT_CSV_FROM_BUCC = "IMPORT_CSV_FROM_BUCC";
export const HELP_ADMIN_AND_REGULAR_USERS = "ADMIN_AND_REGULAR_USERS";
export const HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY = "INCLUDE_CAMPAIGNS_AUTOMATICALLY";
export const HELP_BUDGET_PARTIAL_GOALS = "BUDGET_PARTIAL_GOALS";
export const HELP_GA4_CUSTOM_FIELDS = "GA4_CUSTOM_FIELDS";
export const HELP_LINE_DEFINITION = "LINE_DEFINITION";
export const HELP_ACCOUNT_NOT_LISTED = "ACCOUNT_NOT_LISTED";
export const HELP_SHOPIFY_INSTALL_LINK = "SHOPIFY_INSTALL_LINK";

// El `#…` lleva a una sección del artículo: es el id que el sitio de ayuda le pone a cada título,
// sacado de su texto (`article-outline.ts` del repo del sitio). Si el título se renombra, el link
// abre el artículo arriba: no se rompe. Se usa sólo cuando la pantalla habla de una parte puntual.
const DATA_OF_ARTICLE = {
    [HELP_FLEX_INDICATORS]: {
        "url": "https://ayuda.dashbo.io/es/articles/8486415-columnas-personalizadas-en-tu-agencia"
    },
    [HELP_CHAT_CHANNEL_ID]: {
        "url": "https://ayuda.dashbo.io/es/articles/8554125-envio-de-alertas-y-notificaciones-al-chat-de-tu-agencia-slack-discord-google-chat-y-mas#un-canal-para-cada-cliente"
    },
    [HELP_SHEET] : {
        "url": "https://ayuda.dashbo.io/es/articles/8556847-monitorea-bing-ads-compra-programatica-y-otras-plataformas-a-traves-de-una-google-sheet#2-publicala-como-csv"
    },
    [HELP_WEBHOOK] : {
        "url": "https://ayuda.dashbo.io/es/articles/8557907-enviar-alertas-y-notificaciones-a-un-webhook"
    },
    [HELP_GA4_THOU_SHEETS] : {
        "url": "https://ayuda.dashbo.io/es/articles/11391258-como-asociar-data-de-ga4-a-una-linea-de-control-en-dashbo"
    },
    [HELP_LOOKER_CC] : {
        "url": "https://ayuda.dashbo.io/es/articles/11379867-conecta-dashbo-con-looker-studio"
    },
    [HELP_DATA_NODE] : {
        "url": "https://ayuda.dashbo.io/es/articles/11682862-nodo-de-datos"
    },
    [HELP_DATA_EXPLORER] : {
        "url": "/data-explorer"
    },
    [HELP_MCP] : {
        "url": "https://mcp.ai.dashbo.io/"
    },
    [HELP_MCP_INTERNAL] : {
        "url": "/dashbo-mcp"
    },
    [HELP_GA4] : {
        "url": "https://ayuda.dashbo.io/es/articles/11391258-como-asociar-data-de-ga4-a-una-linea-de-control-en-dashbo"
    },
    [HELP_NO_BUDGETS_ASSIGNED] : {
        "url": "https://ayuda.dashbo.io/es/articles/8569762-por-que-no-veo-ningun-presupuesto-en-el-tablero-principal"
    },
    [HELP_BU_CONFIGURATION_TYPES] : {
        "url": "https://ayuda.dashbo.io/es/articles/8660252-aprende-a-configurar-lineas-de-control-con-los-presupuestos-de-tus-clientes-en-dashbo#como-armarla-segun-tu-plan-de-medios"
    },
    [HELP_FACEBOOK_FIXED_ACTIONS] : {
        "url": "https://ayuda.dashbo.io/es/articles/8148527-configurar-que-evento-considero-como-conversion-en-una-cuenta-de-meta-ads"
    },
    [HELP_DAILY_LIMIT]: {
        "url": "https://ayuda.dashbo.io/es/articles/8149954-evita-perder-el-dinero-de-tus-clientes-con-la-funcion-de-limite-diario"
    },
    [HELP_IMPORT_CSV_FROM_BUCC]: {
        "url": "https://ayuda.dashbo.io/es/articles/8777753-importar-presupuestos-desde-un-archivo-csv#como-tiene-que-ser-el-archivo"
    },
    [HELP_ADMIN_AND_REGULAR_USERS]: {
        "url": "https://ayuda.dashbo.io/es/articles/9146361-diferencias-entre-usuarios-administradores-y-usuarios-regulares"
    },
    [HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY]: {
        "url": "https://ayuda.dashbo.io/es/articles/9641467-como-usar-la-opcion-incluir-automaticamente-campanas#como-se-escriben-las-condiciones"
    },
    [HELP_BUDGET_PARTIAL_GOALS]: {
        "url": "https://ayuda.dashbo.io/es/articles/10394188-presupuestos-por-tramos"
    },
    // Por qué un parámetro de GA4 no aparece en Informes / el Explorador: tiene que estar
    // registrado como dimensión o métrica personalizada en la propiedad.
    [HELP_GA4_CUSTOM_FIELDS]: {
        "url": "https://ayuda.dashbo.io/es/articles/a-56-usa-las-dimensiones-y-metricas-personalizadas-de-ga4-en-dashbo"
    },
    // El artículo canónico «Qué es una línea de seguimiento» (card mFHzKeNK). Es el mismo artículo
    // que HELP_BU_CONFIGURATION_TYPES: el sitio lo resuelve por el id, y el slug quedó el viejo
    // porque la herramienta del Centro de Ayuda no permite cambiarlo.
    [HELP_LINE_DEFINITION]: {
        "url": "https://ayuda.dashbo.io/es/articles/8660252-aprende-a-configurar-lineas-de-control-con-los-presupuestos-de-tus-clientes-en-dashbo"
    },
    // «Conecta tus plataformas y vincula las cuentas de cada cliente»: su FAQ «Una cuenta nueva no
    // aparece en la lista» es la que enlaza el «¿No encuentras la cuenta?» de Vincular cuenta (cc#209).
    [HELP_ACCOUNT_NOT_LISTED]: {
        "url": "https://ayuda.dashbo.io/es/articles/10504617-conecta-tus-centros-de-clientes-con-dashbo#una-cuenta-nueva-no-aparece-en-la-lista"
    },
    // «¿Por qué este paso?» de Shopify por link de instalación (tanda 23/10, id 78): por qué la tienda se
    // conecta con un link hecho para ella mientras Shopify verifica la app pública, y por qué es seguro.
    [HELP_SHOPIFY_INSTALL_LINK]: {
        "url": "https://ayuda.dashbo.io/es/articles/a-78-conectar-shopify-con-un-link-de-instalacion"
    }
}

export const STYLE_WANT_TO_KNOW_MORE = "WANT_TO_KNOW_MORE";

export class LinkToArticleClass extends Component {
    componentDidMount() {
        prefetchHelpCenterIdentity();
    }

    getUrl() {
        const url = DATA_OF_ARTICLE[this.props.article]["url"]
        return url === undefined ? "#" : url;
    }

    renderText() {
        const { t } = this.props;
        if(this.props.text !== undefined && this.props.text !== null && this.props.text.length > 0) {
            return this.props.text;
        }

        if(this.props.type === STYLE_WANT_TO_KNOW_MORE) {
            return t('link_to_article.want_to_know_more');
        }

        return t('link_to_article.want_to_know_more');
    }

    // Los corchetes son el lenguaje de la app clásica. `plain` los saca para las pantallas de la
    // UX 2.1, que no los usan en ningún otro link; sin la prop, el render es el de siempre.
    render() {
        const text = this.renderText();
        return <span className="ms-2 me-2 help_center_link">
            {/* El href se reescribe al abrirlo con quién y desde qué pantalla (ver
                HelpCenterAttribution). mousedown cubre el clic del medio; click, el teclado. */}
            <a href={this.getUrl()} data-help-url={this.getUrl()} target="_blank" rel="noreferrer"
               onMouseDown={attributeHelpCenterClick} onClick={attributeHelpCenterClick}>
                {this.props.plain === true ? text : `[${text}]`}
            </a>
        </span>
    }

    prefix() {
        if (this.props.prefix === undefined) {
            return 'fas'
        } else {
            return this.props.prefix
        }
    }
}

export const LinkToArticle = withTranslation()(LinkToArticleClass);
export default LinkToArticle;
